module.exports = __webpack_public_path__ + "img/40_38_048_420.ea5ff025.jpg";